import BaseModel from 'volta/models/base-model';

import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

import type { IResourceName } from 'volta/models/base-model';
import type PartType from 'volta/models/part-type';

export const PartQueries = {
  Tags: 'Tags'
};

export const PartResourceName: IResourceName = {
  singular: 'part',
  plural: 'parts'
};

export default class Part extends BaseModel {
  @attr('string') code!: string;
  @attr('string') description?: string;
  @belongsTo('part-type', { async: false, inverse: null }) partType?: PartType;
  @attr('string') unitMeasure!: string;
  @attr('string') purchaseUnitMeasure?: string;
  @attr('string') productionUnitMeasure?: string;
  @attr('array') tags!: string[];
  @attr('string') externalId?: string;

  get partId() {
    return this.id;
  }

  [Type] = 'part' as const;
}
